/* unplugin-vue-components disabled */import { render } from "./ChapterDocumentViewer.vue?vue&type=template&id=b0757ac2&scoped=true&ts=true"
import script from "./ChapterDocumentViewer.vue?vue&type=script&lang=ts"
export * from "./ChapterDocumentViewer.vue?vue&type=script&lang=ts"

import "./ChapterDocumentViewer.vue?vue&type=style&index=0&id=b0757ac2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0757ac2"]])

export default __exports__